import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

import { type ITaskType } from '../model';

const typeToContent: Record<ITaskType, string> = {
  App: 'Application',
  Company: 'Organization',
  ContinuityEscrow: 'Continuity Escrow',
  CustodianProfile: 'Software Custodian',
  SaasEscrow: 'SaaS Escrow',
  SoftwareEscrow: 'Software Escrow',
};

type Props = {
  type: ITaskType;
};

const TypeTooltip = ({ type, children }: React.PropsWithChildren<Props>) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side="right"
          align="center"
          className="max-w-[281px] bg-white text-sm text-popover-foreground shadow-md border-border"
        >
          {typeToContent[type]}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TypeTooltip;
